import * as DOMPurify from 'dompurify';
import * as React from 'react';

export const useMessageHtml = (htmlText?: string | null) => {
  return React.useMemo(() => {
    if (!htmlText) {
      return null;
    }

    const trimmedText = htmlText.trim();

    if (!trimmedText) {
      return null;
    }

    const sanitizedText = DOMPurify.sanitize(trimmedText);

    if (!sanitizedText) {
      return null;
    }

    return sanitizedText.replace(new RegExp('\\n', 'g'), '<br/>');
  }, [htmlText]);
};
